import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  padding: 12px;
  background: ${({ theme }) => theme.palette.white};
`;
